import axiosInstance from '../../config/axiosInstance';
import { CreatePremiumPayload, MyStationPrice, PremiumGrantV2 } from '../../types/premium';

/**
 * Organization premium prices. `organizationId` undefined addresses the
 * caller's own organization (owner or member with premium.manage); a value
 * is the platform-admin path for any organization.
 */
export class PremiumService {
  private basePath(organizationId?: string): string {
    return `/organizations/${organizationId ?? 'my'}/premiums`;
  }

  async list(organizationId?: string): Promise<PremiumGrantV2[]> {
    return axiosInstance.get(this.basePath(organizationId));
  }

  async create(payload: CreatePremiumPayload, organizationId?: string): Promise<PremiumGrantV2> {
    return axiosInstance.post(this.basePath(organizationId), payload);
  }

  async updatePrice(
    id: string,
    pricePerKwh: number,
    organizationId?: string,
  ): Promise<PremiumGrantV2> {
    return axiosInstance.patch(`${this.basePath(organizationId)}/${id}`, { pricePerKwh });
  }

  async remove(id: string, organizationId?: string): Promise<{ deleted: true }> {
    return axiosInstance.delete(`${this.basePath(organizationId)}/${id}`);
  }

  /** What the signed-in driver pays per kWh at a station. */
  async myPrice(stationId: string): Promise<MyStationPrice> {
    return axiosInstance.get('/premium/my-price', { params: { stationId } });
  }
}

export const premiumService = new PremiumService();
